import React, { useState } from "react";
import Report from "../components/Report";
import { SubmitButton } from "../components/Buttons";
import "../css/forms.css";
import PatientsForm from "../forms/PatientsForm";
import Modal from "../components/Modal";
import GenericPage from "./GenericPage";

const PatientsPage = () => {
  const [showPatientsFormModal, setShowPatientsFormModal] = useState(false);
  const [patientDataModal, setPatientDataModal] = useState(null);
  const [formTitle, setFormTitle] = useState(null);

  const displayPatientsFormModal = (patientData, formTitle) => {
    setPatientDataModal(patientData);
    setFormTitle(formTitle)
    setShowPatientsFormModal(true);
  }

  const patientsData = [
    {
      "Tipo de Documento": "DNI",
      "Número de identificación": "1012345678",
      "Nombre del paciente": "Juan Pérez",
      País: "Uruguay",
      Teléfono: "(+598) 90000000",
      Dirección: "Calle Ejemplo 123",
      "Entidad aseguradora de salud": "Entidad 1",
      "Correo electrónico": "juan@example.com",
    },
    {
      "Tipo de Documento": "DNI",
      "Número de identificación": "2023456789",
      "Nombre del paciente": "María Rodríguez",
      País: "Uruguay",
      Teléfono: "(+598) 91111111",
      Dirección: "Avenida de Prueba 456",
      "Entidad aseguradora de salud": "Entidad 2",
      "Correo electrónico": "maria@example.com",
    },
    {
      "Tipo de Documento": "DNI",
      "Número de identificación": "3034567890",
      "Nombre del paciente": "Luis González",
      País: "Uruguay",
      Teléfono: "(+598) 92222222",
      Dirección: "Calle de Muestra 789",
      "Entidad aseguradora de salud": "Entidad 3",
      "Correo electrónico": "luis@example.com",
    },
    {
      "Tipo de Documento": "DNI",
      "Número de identificación": "4045678901",
      "Nombre del paciente": "Ana Fernández",
      País: "Uruguay",
      Teléfono: "(+598) 93333333",
      Dirección: "Avenida Principal 456",
      "Entidad aseguradora de salud": "Entidad 4",
      "Correo electrónico": "ana@example.com",
    },
    {
      "Tipo de Documento": "DNI",
      "Número de identificación": "5056789012",
      "Nombre del paciente": "Martín Silva",
      País: "Uruguay",
      Teléfono: "(+598) 94444444",
      Dirección: "Calle Secundaria 789",
      "Entidad aseguradora de salud": "Entidad 5",
      "Correo electrónico": "martin@example.com",
    },
    {
      "Tipo de Documento": "DNI",
      "Número de identificación": "6067890123",
      "Nombre del paciente": "Laura Pérez",
      País: "Uruguay",
      Teléfono: "(+598) 95555555",
      Dirección: "Avenida Secundaria 1011",
      "Entidad aseguradora de salud": "Entidad 6",
      "Correo electrónico": "laura@example.com",
    },
    {
      "Tipo de Documento": "DNI",
      "Número de identificación": "7078901234",
      "Nombre del paciente": "Carlos Rodríguez",
      País: "Uruguay",
      Teléfono: "(+598) 96666666",
      Dirección: "Calle de Ejemplo 1213",
      "Entidad aseguradora de salud": "Entidad 7",
      "Correo electrónico": "carlos@example.com",
    },
    {
      "Tipo de Documento": "DNI",
      "Número de identificación": "8089012345",
      "Nombre del paciente": "Silvia González",
      País: "Uruguay",
      Teléfono: "(+598) 97777777",
      Dirección: "Avenida de Prueba 1415",
      "Entidad aseguradora de salud": "Entidad 8",
      "Correo electrónico": "silvia@example.com",
    },
    {
      "Tipo de Documento": "DNI",
      "Número de identificación": "9090123456",
      "Nombre del paciente": "Javier Fernández",
      País: "Uruguay",
      Teléfono: "(+598) 98888888",
      Dirección: "Calle de Test 1617",
      "Entidad aseguradora de salud": "Entidad 9",
      "Correo electrónico": "javier@example.com",
    },
    {
      "Tipo de Documento": "DNI",
      "Número de identificación": "1001234501",
      "Nombre del paciente": "Gabriela Silva 01",
      País: "Uruguay",
      Teléfono: "(+598) 99999999",
      Dirección: "Avenida de Muestra 1819",
      "Entidad aseguradora de salud": "Entidad 10",
      "Correo electrónico": "gabriela@example.com",
    },
    {
      "Tipo de Documento": "DNI",
      "Número de identificación": "1001234502",
      "Nombre del paciente": "Gabriela Silva 02",
      País: "Uruguay",
      Teléfono: "(+598) 99999999",
      Dirección: "Avenida de Muestra 1819",
      "Entidad aseguradora de salud": "Entidad 10",
      "Correo electrónico": "gabriela@example.com",
    },
    {
      "Tipo de Documento": "DNI",
      "Número de identificación": "1001234503",
      "Nombre del paciente": "Gabriela Silva 03",
      País: "Uruguay",
      Teléfono: "(+598) 99999999",
      Dirección: "Avenida de Muestra 1819",
      "Entidad aseguradora de salud": "Entidad 10",
      "Correo electrónico": "gabriela@example.com",
    },
    {
      "Tipo de Documento": "DNI",
      "Número de identificación": "1001234504",
      "Nombre del paciente": "Gabriela Silva 04",
      País: "Uruguay",
      Teléfono: "(+598) 99999999",
      Dirección: "Avenida de Muestra 1819",
      "Entidad aseguradora de salud": "Entidad 10",
      "Correo electrónico": "gabriela@example.com",
    },
    {
      "Tipo de Documento": "DNI",
      "Número de identificación": "1001234505",
      "Nombre del paciente": "Gabriela Silva 05",
      País: "Uruguay",
      Teléfono: "(+598) 99999999",
      Dirección: "Avenida de Muestra 1819",
      "Entidad aseguradora de salud": "Entidad 10",
      "Correo electrónico": "gabriela@example.com",
    },
    {
      "Tipo de Documento": "DNI",
      "Número de identificación": "1001234506",
      "Nombre del paciente": "Gabriela Silva 06",
      País: "Uruguay",
      Teléfono: "(+598) 99999999",
      Dirección: "Avenida de Muestra 1819",
      "Entidad aseguradora de salud": "Entidad 10",
      "Correo electrónico": "gabriela@example.com",
    },
    {
      "Tipo de Documento": "DNI",
      "Número de identificación": "1001234507",
      "Nombre del paciente": "Gabriela Silva 07",
      País: "Uruguay",
      Teléfono: "(+598) 99999999",
      Dirección: "Avenida de Muestra 1819",
      "Entidad aseguradora de salud": "Entidad 10",
      "Correo electrónico": "gabriela@example.com",
    },
    {
      "Tipo de Documento": "DNI",
      "Número de identificación": "1001234508",
      "Nombre del paciente": "Gabriela Silva 08",
      País: "Uruguay",
      Teléfono: "(+598) 99999999",
      Dirección: "Avenida de Muestra 1819",
      "Entidad aseguradora de salud": "Entidad 10",
      "Correo electrónico": "gabriela@example.com",
    },
    {
      "Tipo de Documento": "DNI",
      "Número de identificación": "1001234509",
      "Nombre del paciente": "Gabriela Silva 09",
      País: "Uruguay",
      Teléfono: "(+598) 99999999",
      Dirección: "Avenida de Muestra 1819",
      "Entidad aseguradora de salud": "Entidad 10",
      "Correo electrónico": "gabriela@example.com",
    },
    {
      "Tipo de Documento": "DNI",
      "Número de identificación": "1001234510",
      "Nombre del paciente": "Gabriela Silva 10",
      País: "Uruguay",
      Teléfono: "(+598) 99999999",
      Dirección: "Avenida de Muestra 1819",
      "Entidad aseguradora de salud": "Entidad 10",
      "Correo electrónico": "gabriela@example.com",
    },
    {
      "Tipo de Documento": "DNI",
      "Número de identificación": "10012345611",
      "Nombre del paciente": "Gabriela Silva 11",
      País: "Uruguay",
      Teléfono: "(+598) 99999999",
      Dirección: "Avenida de Muestra 1819",
      "Entidad aseguradora de salud": "Entidad 10",
      "Correo electrónico": "gabriela@example.com",
    },
  ];

  return (
    <>
      <GenericPage active="Pacientes">
        <div className="report-header">
          <div className="report-title">
            <h1>Pacientes</h1>
          </div>
          <div className="report-button">
            <SubmitButton
              text="Nuevo"
              onClickButton={() => displayPatientsFormModal(null, "Crear")}
            />
          </div>
        </div>
        <Report data={patientsData} edit={true} onEditClick={displayPatientsFormModal} />
      </GenericPage>
      {showPatientsFormModal && (
        <Modal onClickCloseBtn={() => setShowPatientsFormModal(false)}>
          <PatientsForm data={patientDataModal} formTitle={formTitle} />
        </Modal>
      )}
    </>
  );
};

export default PatientsPage;
